<script>
import { compile, defineAsyncComponent, h } from 'vue';
import { controlStore, createStoreIndex } from './controlStore.js';
import { controlMixins } from "./controlMixins.js";

let editorSettings = {};

export const listItemComponent = {
    editorSettings: editorSettings,
    mixins: [controlMixins],
    props: {
        data: {
            default: {}
        }
    },
    data: function () {
        return {
            template: "",
            hovered: false,
            subControlIds: []
        };
    },
    components: {
        'control': defineAsyncComponent(() => import('@common/control/control.vue')),
        labelWrapper: defineAsyncComponent(() => import('@common/control/labelWrapper')),
        settingsCog: defineAsyncComponent(() => import('@common/settingsEditor/settingsEditorCog.vue'))
    },
    render: function () {
        if (this.$parent.config && this.$parent.config.itemContentTemplate) {
            let re = /<control.+?(?!>)name="([^'][A-Za-z0-9 _]*)".+?(?!>)/mg;
            let template = this.$parent.config.itemContentTemplate || '';
            if (template && !this.template) {
                template = template.replace(re, this.replacer);
                let storeId = library.getFromParents(this.$parent, { storeId: '!!' }, 'storeId');
                if (!Array.isArray(storeId)) storeId = [storeId];
                if (this.subControlIds.length) {
                    this.subControlIds.forEach((controlName) => {
                        let controlConfig = library.cloneObj(this.component.controlConfigs[controlName.split('__')[0]]);
                        if (controlConfig.initOnRender) return;
                        controlConfig.name = controlName;
                        let controlStoreIndex = createStoreIndex([...storeId, this.name], controlName);
                        controlStore().addControl(controlConfig, this.component, controlStoreIndex);
                    });
                }
                this.template = compile(template);
            }
        }
        return h(this.template(this));
    },
    computed: {
        dataTestId() {
            return this.$parent.dataTestId;
        },
        component() {
            return this.$parent.component;
        }
    },
    methods: {
        replacer: function (match, initialName) {
            let controlName = initialName + '__' + (this.data.key || this.data.originKey);
            if (this.subControlIds.indexOf(controlName) === -1) this.subControlIds.push(controlName);
            return match.replace(initialName, controlName);
        },
        onMouseenter(event) {
            if (this.config.eventMethods && this.config.eventMethods.onMouseenter) {
                this.action(event, 'onMouseenter');
            }
            this.hovered = true;
        },
        async onMouseleave(event) {
            await this.allSubControlPopupsClosed();
            if (this.config.eventMethods && this.config.eventMethods.onMouseleave) {
                this.action(event, 'onMouseleave');
            }
            this.hovered = false;
        },
        async allSubControlPopupsClosed() {
            let hasVisibleSubControl = () => {
                let anyVisible = false;
                this.subControlIds.some((subControlId) => {
                    let subControlPopupId = `${this.dataTestId}_${subControlId}-popup`;
                    let visiblePopup = document.getElementById(subControlPopupId);
                    anyVisible = !!visiblePopup;
                    return !!visiblePopup;
                });
                return anyVisible;
            };
            return new Promise((resolve) => {
                if (!hasVisibleSubControl()) resolve();
                let popupInterval = setInterval(() => {
                    if (!hasVisibleSubControl()) {
                        clearInterval(popupInterval);
                        resolve();
                    }
                }, 500); // NOSONAR
            });
        }
    }
};

export default listItemComponent;
</script>
